<div class="page-container" [class.loading]="isLoading">
    <div class="flex justify-end">
        <input type="checkbox" [ngModel]="includeTerminated" name="fill" tabindex="0" class="hidden" />
        <label>{{ 'reporting.reports.includeTerminatedEmployees' | translate }}</label>
    </div>

    <app-header title="reporting.reports.insightsMissingEmployeeData" [back]="true"></app-header>

    <div class="ui table segment">
        <table class="ui selectable table" *ngIf="reportableFields?.length">
            <thead>
                <tr>
                    <th>{{ 'reporting.reports.fieldLabel' | translate }}</th>
                    <th class="center aligned">{{ 'reporting.reports.missingCount' | translate }}</th>
                    <th class="center aligned">{{ 'reporting.reports.dataCompletion' | translate }}</th>
                    <th class="center aligned" style="width: 120px">
                        {{ 'reporting.reports.dataHealth' | translate }}
                    </th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngFor="let field of reportableFields; let index = index">
                    <tr (click)="toggleDetails(index)">
                        <td>{{ field.label | translate }}</td>
                        <td class="center aligned">
                            <ui-badge [type]="field.badCount > 0 ? 'danger' : 'default'">{{ field.badCount }}</ui-badge>
                        </td>
                        <td class="center aligned">
                            <ui-badge [type]="getBadgeType(field)">{{ getCompletionPercentage(field) }} %</ui-badge>
                            <ui-badge>{{ field.goodCount }} / {{ field.totalCount }}</ui-badge>
                        </td>
                        <td class="center aligned">
                            <ng-container *ngIf="field.goodCount >= field.totalCount">
                                <ui-badge type="success"><mat-icon svgIcon="check"></mat-icon></ui-badge>
                            </ng-container>
                            <ng-container *ngIf="field.goodCount < field.totalCount">
                                <ui-badge type="danger"><mat-icon svgIcon="close"></mat-icon></ui-badge>
                            </ng-container>
                        </td>
                    </tr>
                    <tr class="details" *ngIf="field?.employees?.length" [attr.index]="index">
                        <td colspan="4">
                            <div class="inner-details">
                                <table class="ui striped compact small table">
                                    <tr *ngFor="let employee of field.employees" (click)="openEmployee(employee)">
                                        <td>
                                            <app-avatar [employee]="employee" [name]="true"></app-avatar>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </td>
                    </tr>
                </ng-container>
            </tbody>
        </table>
    </div>
</div>
